<template>
  <div class="stats">
    <new-customers :qty="newcustomers"></new-customers>
    <domicilied-customers :qty="domiciliatedCustomers"></domicilied-customers>
    <active-customers :qty="activecustomers"></active-customers>
    <prospects :qty="prospects"></prospects>
  </div>
</template>

<style lang="scss" scoped>
  .stats {
    padding: 0;
    width: 100%;
    margin: 0 0 10px;
  }
</style>

<script type="text/babel">
  import NewCustomers from 'components/Dashboard/Stats/NewCustomers'
  import ActiveCustomers from 'components/Dashboard/Stats/ActiveCustomers'
  import DomiciliedCustomers from 'components/Dashboard/Stats/DomiciliedCustomers'
  import Prospects from 'components/Dashboard/Stats/Prospects'

  export default {
    name: "Stats",

    props: ["newcustomers", "activecustomers", "prospects", "domiciliatedCustomers"],

    components: {
      NewCustomers,
      ActiveCustomers,
      DomiciliedCustomers,
      Prospects,
    },

    data () {
      return {

      }
    },
  }
</script>



// WEBPACK FOOTER //
// client/components/Dashboard/Stats.vue